import axios from 'axios'
import { SALES_SECTION_API_ENDPOINT } from 'shared/envs'
import { isomorphicCookies } from 'shared/storage'

const baseURL = SALES_SECTION_API_ENDPOINT()

export const httpClientSales = axios.create({
  baseURL
})

httpClientSales.interceptors.request.use(request => {
  const token = isomorphicCookies.getAll()?.token || ''
  if (token) {
    request.headers.Authorization = `Bearer ${token}`
  }
  return request
})
